export default "__VITE_ASSET__WUP65ITa__"